import { type PropType } from 'vue';
import {
    UPDATE_MODEL_VALUE,
    type ComponentSizes, componentSizeProp,
    type ComponentView, componentViewProp,
    type ClearableType, clearableProp,
} from '../../constants';

export interface TextareaProps {
    modelValue?: string;
    size?: ComponentSizes;
    view?: ComponentView;
    placeholder?: string;
    disabled?: boolean;
    readonly?: boolean;
    clearable?: ClearableType;
    autosize?: boolean;
    rows?: number;
    resize?: 'none' | 'both' | 'horizontal' | 'vertical';
}

export const textareaProps = {
    modelValue: {
        type: String as PropType<TextareaProps['modelValue']>,
        default: undefined,
        required: false,
    },
    size: componentSizeProp,
    view: componentViewProp,
    placeholder: {
        type: String as PropType<TextareaProps['placeholder']>,
        default: undefined,
        required: false,
    },
    disabled: {
        type: Boolean as PropType<TextareaProps['disabled']>,
        default: undefined,
        required: false,
    },
    readonly: {
        type: Boolean as PropType<TextareaProps['readonly']>,
        default: undefined,
        required: false,
    },
    clearable: clearableProp,
    autosize: {
        type: Boolean as PropType<TextareaProps['autosize']>,
        default: undefined,
        required: false,
    },
    rows: {
        type: Number as PropType<TextareaProps['rows']>,
        default: undefined,
        required: false,
    },
    resize: {
        type: String as PropType<TextareaProps['resize']>,
        default: 'none',
        required: false,
    },
};

export const textareaEmits = {
    [UPDATE_MODEL_VALUE]: (event: string) => event,
    input: (event: string) => event,
    change: (event: string) => event,
    focus: (event: string) => event,
    blur: (event: string) => event,
    clear: (event: string) => event,
};
